var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import "../styles/SlideSelector.css";
import Selector from "./Selector";
var SlideSelector = /** @class */ (function (_super) {
    __extends(SlideSelector, _super);
    function SlideSelector(props) {
        var _this = _super.call(this, props) || this;
        _this.renderSlideSelectors = function () {
            var _a = _this.props, numberOfSlide = _a.numberOfSlide, selectedIndex = _a.selectedIndex, selectorStyle = _a.selectorStyle;
            var selectors = [];
            for (var i = 0; i < numberOfSlide; i++) {
                selectors.push(React.createElement("div", { key: "Selector-" + i, className: "Slider-Slide-Selector-Container" },
                    React.createElement(Selector, { index: i, isSelected: selectedIndex === i, onPress: _this.props.onPress, selectorStyle: selectorStyle })));
            }
            return selectors;
        };
        return _this;
    }
    SlideSelector.prototype.render = function () {
        var selectorContainerStyle = this.props.selectorContainerStyle;
        return (React.createElement("div", { className: "Slider-Slide-Selectors-Container", style: selectorContainerStyle }, this.renderSlideSelectors()));
    };
    return SlideSelector;
}(React.PureComponent));
export default SlideSelector;
//# sourceMappingURL=SlideSelector.js.map